import React, { useState, useEffect } from "react";
import "../styles/AdminMenu.css";
import { useNavigate, useLocation } from "react-router-dom";
import { User } from "../types/User";

interface AdminMenuProps {
  currentUser: User;
}

const AdminMenu: React.FC<AdminMenuProps> = ({ currentUser }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [open, setOpen] = useState(false);

  const [reportOpen, setReportOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === "Escape" && open) {
        setOpen(false);
      }
    };

    if (open) {
      document.addEventListener("keydown", handleEscape);
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.removeEventListener("keydown", handleEscape);
      document.body.style.overflow = "unset";
    };
  }, [open]);

  const handleNavigate = (path: string) => {
    navigate(path);
    setOpen(false);
  };

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    return location.pathname.startsWith(path);
  };
  const menuItems = [
    { path: "/admin", icon: "bi-people", label: "Gestion des utilisateurs", exact: true, minRank:5},
    { path: "/admin/offre", icon: "bi-file-earmark-text", label: "Gestion d'appel d'offre", minRank:5},
    { path: "/admin/projet", icon: "bi-card-checklist", label: "Gestion de projet", minRank:5},
    { path: "/admin/menu", icon: "bi-diagram-3", label: "Gestion de menu", minRank:5}, 
    { path: "/agent", icon: "bi-folder2-open", label: "Espace Agents", minRank:1},
    { path: "/technicien", icon: "bi-gear", label: "Espace Techniciens", minRank:2 },
    { path: "/sap", icon: "bi-bell", label: "Système d'alerte précoce", minRank:3},
    { path: "/", icon: "bi-map", label: "Site", minRank:2 },
  ];

  const visibleItems = menuItems.filter((item) => {
    const rank = currentUser.roleRank ?? 0;
    return rank >= item.minRank;
  });

  return (
    <>
      <button
        className="menu-toggle"
        onClick={() => setOpen(!open)}
        aria-label={open ? "Fermer le menu" : "Ouvrir le menu"}
        aria-expanded={open}
      >
        <i className={open ? "bi bi-x-lg" : "bi bi-list"}></i>
      </button>

      <div
        className={`menu-overlay ${open ? "visible" : ""}`}
        onClick={() => setOpen(false)}
        aria-hidden="true"
      />

      <nav className={`admin-menu ${open ? "open" : ""}`} aria-label="Menu principal">
        <h5 className="menu-title">
          <i className="bi bi-speedometer2"></i> {currentUser.role}
        </h5>

        <div style={{ marginTop: -20 }}>
          <hr className="my-3 py-2" />
        </div>

        <ul className="menu-list" role="menu">
          {visibleItems.map((item) => (
            <li
              key={item.path}
              className={`menu-item ${
                item.exact
                  ? location.pathname === item.path
                    ? "active"
                    : ""
                  : isActive(item.path)
                  ? "active"
                  : ""
              }`}
              onClick={() => handleNavigate(item.path)}
              role="menuitem"
              tabIndex={0}
              onKeyPress={(e) => {
                if (e.key === "Enter" || e.key === " ") handleNavigate(item.path);
              }}
            >
              <i className={`${item.icon} me-2`}></i>
              {item.label}
            </li>
          ))}
          {(currentUser.roleRank ?? 0) >= 2 && (
            <>
              <li
                className={`menu-item drawer ${isActive("/rapport") ? "active" : ""}`}
                onClick={() => setReportOpen(!reportOpen)}
                role="menuitem"
                tabIndex={0}
              >
                <i className="bi bi-journal me-2"></i>
                Gestion de rapport
                <i className={`ms-auto bi ${reportOpen ? "bi-chevron-up" : "bi-chevron-down"}`}></i>
              </li>

              {reportOpen && (
                <ul className="submenu">
                  <li
                    className={`submenu-item ${isActive("/rapport-modeles") ? "active" : ""}`}
                    onClick={() => handleNavigate("/rapport-modeles")}
                  >
                    <i className="bi bi-journal-text me-2"></i>
                    Modèles de rapports
                  </li>

                  <li
                    className={`submenu-item ${isActive("/rapport-list") ? "active" : ""}`}
                    onClick={() => handleNavigate("/rapport-list")}
                  >
                    <i className="bi bi-list-check me-2"></i>
                    Liste des rapports générés
                  </li>
                </ul>
              )}
            </>
          )}
        </ul>
      </nav>
    </>
  );
};

export default AdminMenu;
